export default __webpack_public_path__ + "static/media/logo.d74822a1.gif";